module.exports = __webpack_public_path__ + "static/media/kubernetes.ea798a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/devops/kubernetes.png
// module id = 1527
// module chunks = 0